import { Field, getIn } from "formik";
import React from "react";

import { getAutomationDataAttr } from "../../../utils/automationUtils";
import Input from "../Input";
import InputError from "../InputError";
import Label from "../Label";

import "./styles.scss";

const GenericInput = (props) => {
  const {
    change,
    containerClasses,
    "data-testid": dataTestId,
    disabled,
    errorClasses,
    errors,
    formEl,
    inputClasses,
    testId,
    touched,
  } = props;

  const testLocatorId = dataTestId || formEl.testLocatorId;

  let errorData = getIn(errors, formEl.name);
  let isTouched = getIn(touched, formEl.name);
  const className = `Input ${props.inputBorderDisabled} ${props.grayBorder} ${
    errorData && isTouched ? "is-invalid" : ""
  } ${inputClasses ? inputClasses : ""}`;

  let extraProps = {};

  if (change) {
    extraProps["onChange"] = change;
  }

  let errorTestId;

  if (testId) {
    extraProps = { ...extraProps, ...getAutomationDataAttr(testId) };
    errorTestId = `${testId}-error`;
  }

  if (testLocatorId) {
    extraProps = { ...extraProps, "data-testid": testLocatorId };
    errorTestId = errorTestId || `${testLocatorId}-error`;
  }

  return (
    <div className={`FormGroup ${props.clinicialTextbox} ${containerClasses}`}>
      {!formEl.elementConfig.hideTopLabel && (
        <Label classes={formEl.elementConfig.labelClasses}>
          <span>{formEl.elementConfig.label}</span>
          {formEl.elementConfig.optional && (
            <span className="GenericInput--optional">(Optional)</span>
          )}
          {formEl.elementConfig.subtext && (
            <p className="GenericInput--subtext">{formEl.elementConfig.subtext}</p>
          )}
        </Label>
      )}
      <Field
        autocomplete={formEl?.autocomplete ?? "on"}
        checked={formEl.elementConfig.checked}
        className={className}
        component={Input}
        disabled={disabled}
        elementConfig={formEl.elementConfig}
        elementtype={formEl.elementType}
        id={formEl.id}
        name={formEl.name}
        onchange={formEl.onchange}
        onclick={formEl.onclick}
        options={formEl.elementConfig.options}
        placeholder={formEl.elementConfig.placeholder}
        type={formEl.elementConfig.type}
        {...extraProps}
      />
      {errorData && isTouched ? (
        <InputError classes={errorClasses ? errorClasses : null} testId={errorTestId}>
          {errorData}
        </InputError>
      ) : null}
    </div>
  );
};

export default GenericInput;
